import { LoadingSpinner } from "@newsela/angelou";

import { CollapsibleTags } from "../CollapsibleTags";
import { TAXONOMY_TOPICS_ALLOWED } from "../TaxonomyTags.constants";
import { ITaxonomyCategorizedData } from "../TaxonomyTags.types";
import { ITabsStructure } from "./TaxonomyModalTabs.types";

export const createTabs = (
  filteredData: ITaxonomyCategorizedData,
  isLoadingTaxonomyData: boolean,
): ITabsStructure[] => {
  const level0Data = filteredData["level0"] || [];
  const level1Data = filteredData["level1"] || [];

  const parentOrder: { [key: string]: number } = {};
  level0Data.forEach((item, index) => {
    if (item.id) {
      parentOrder[item.id] = index;
    }
  });

  const dataIsOk = level0Data.length > 0 || level1Data.length > 0;

  const allTags = dataIsOk ? (
    <CollapsibleTags
      categorizedData={filteredData}
      level1Tags={level1Data.sort((a, b) => {
        const parentOrderA = parentOrder[a.parentId ?? ""];
        const parentOrderB = parentOrder[b.parentId ?? ""];
        return (parentOrderA ?? 0) - (parentOrderB ?? 0);
      })}
    />
  ) : isLoadingTaxonomyData ? (
    <LoadingSpinner />
  ) : (
    <span>Error: No Taxonomy tags were found.</span>
  );

  const tabs: ITabsStructure[] = [
    {
      name: "All",
      panelId: "all",
      panelContent: allTags,
    },
  ];

  level0Data
    .filter((lvl0) => TAXONOMY_TOPICS_ALLOWED.includes(lvl0.value))
    .forEach((level0) => {
      const filteredTags = level1Data.filter(
        (tag) => tag.parentId === level0.id,
      );

      const currentTab: ITabsStructure = {
        name: level0.label,
        panelId: level0.value,
        panelContent: (
          <CollapsibleTags
            level1Tags={filteredTags}
            categorizedData={filteredData}
          />
        ),
      };

      tabs.push(currentTab);
    });

  return tabs;
};
